"use strict";

var LoggerInstance = require("js-logger").get("GooglePayHelper");

var CheckoutActions = require("./CheckoutActions");

var AccountFormHelper = require("../accountComponents/AccountFormHelper");

var Spinner = require("../client/Spinner");

var CheckoutHelper = require("../commonComponents/CheckoutHelper");

var StringConstants = require("../constants/StringConstants");

var Constants = require("../designer/Constants");

var ApiHelper = require("../shared/ApiHelper");
var BootstrapPrompt = require("../shared/BootstrapPrompt");
var ReCAPTCHAHelper = require("../shared/ReCAPTCHAHelper");

module.exports = {
	initialize: function () {
		// Once the page has loaded, if PaymentRequest is not defined, we should remove the component.
		document.addEventListener("DOMContentLoaded", () => {
			setTimeout(() => {
				var googlePayConfiguration = CheckoutActions.getGooglePayConfiguration();

				if (googlePayConfiguration.isEnabled === "N" || !window.PaymentRequest) {
					$("[data-component='googlePay']").remove();
				}
			}, 0);
		});
	},

	initializeGooglePay: function ($button) {
		var that = this;
		var googlePayConfiguration = CheckoutActions.getGooglePayConfiguration();
		var isDesignMode = $button && $button.length > 0;

		const paymentsClient = new google.payments.api.PaymentsClient({ environment: googlePayConfiguration.environment });

		var $buttonComponent = (isDesignMode && $button) || $("[data-component='googlePay.button']");

		const button = paymentsClient.createButton({
			onClick: () => {
				that.onGooglePayButtonClicked();
			},
			allowedPaymentMethods: ["CARD"],
			buttonColor: "default",
			buttonSizeMode: "fill",
			buttonType: "plain"
		});

		$buttonComponent.empty();
		$buttonComponent.append(button);

		if (isDesignMode) {
			// We are loading the real button in the designer and need to block click events
			$buttonComponent.find("button").css("pointer-events", "none");
		}
	},

	onGooglePayButtonClicked: function (event) {
		Spinner.showSpinner();

		var components = CheckoutActions.getComponentsForCheckoutValidation(Constants.CHECKOUT_VALIDATION_TYPES.ALTERNATIVE_BUTTON_CHECKOUT);
		var addressStandardizationOptions = { primaryAddressFormName: AccountFormHelper.getPrimaryAddressFormName() };
		var googlePayErrorMessages = CheckoutActions.getGooglePayDisplayMessages();
		googlePayErrorMessages.paymentCreationErrorLogMessage = "Google Pay Error: Unable to create valid payment information for processing the selected payment.";

		CheckoutActions.validateCheckout(null, { components }, addressStandardizationOptions).always(validationResult => {
			if (!validationResult.isValid) {
				// Our normal validation error messages have already been displayed at this point.
				Spinner.removeSpinner();
				return;
			}

			CheckoutHelper.getCheckoutData().always(dataToSend => {
				if (!dataToSend) {
					// Our normal data collection error messages have already been displayed at this point.
					Spinner.removeSpinner();
					return;
				}

				// We have to perform a reCAPTCHA challenge before displaying the Payment Screen
				ReCAPTCHAHelper.getToken(StringConstants.ReCAPTCHAActions.GoogleCheckout).always(token => {
					if (token) {
						dataToSend.reCAPTCHAResponseToken = token;
					}

					const paymentRequest = this.getGooglePayPaymentRequest(googlePayErrorMessages);
					if (paymentRequest) {
						this.performGooglePayCheckout(paymentRequest, dataToSend, googlePayErrorMessages);
					}
				});
			});
		});
	},

	getGooglePayPaymentRequest: function (googlePayErrorMessages) {
		var googlePayConfiguration = CheckoutActions.getGooglePayConfiguration();

		const paymentMethodData = [{
			"supportedMethods": "https://google.com/pay",
			"data": {
				"environment": googlePayConfiguration.environment,
				"apiVersion": 2,
				"apiVersionMinor": 0,
				"merchantInfo": {
					"merchantId": googlePayConfiguration.merchantIdentifier || "",
					"merchantName": googlePayConfiguration.merchantDisplayName
				},
				"allowedPaymentMethods": [{
					"type": 'CARD',
					"parameters": {
						"allowedAuthMethods": ["PAN_ONLY", "CRYPTOGRAM_3DS"],
						"allowedCardNetworks": ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"], // This is all Google's allowed networks.
					},
					"tokenizationSpecification": {
						"type": 'PAYMENT_GATEWAY',
						"parameters": {
							"gateway": "cardconnect",
							"gatewayMerchantId": googlePayConfiguration.paymentProviderIdentifier || ""
						}
					}
				}],
				"transactionInfo": {
					"totalPriceStatus": "FINAL",
					"totalPrice": `${CheckoutActions.getTotalAmount()}`,
					"totalPriceLabel": "DonorDirect",
					"currencyCode": CheckoutActions.getCurrency(),
					"checkoutOption": "COMPLETE_IMMEDIATE_PURCHASE",
					"countryCode": googlePayConfiguration.merchantCountry
				}
			}
		}];

		const paymentOptions = {
			"requestPayerName": false,
			"requestBillingAddress": false,
			"requestPayerEmail": false,
			"requestPayerPhone": false,
			"requestShipping": false,
			"shippingType": "shipping"
		};

		const paymentDetails = {
			"total": {
				"type": "final",
				"label": googlePayConfiguration.merchantDisplayName,
				"amount": {
					"value": CheckoutActions.getTotalAmount(),
					"currency": CheckoutActions.getCurrency()
				}
			}
		};

		try {
			return new PaymentRequest(paymentMethodData, paymentDetails, paymentOptions);
		} catch (exception) {
			LoggerInstance.error(exception);
			BootstrapPrompt.alert(googlePayErrorMessages.paymentUnavailable);
			Spinner.removeSpinner();
			return null;
		}
	},

	performGooglePayCheckout: function (paymentRequest, dataToSend, googlePayErrorMessages) {
		// Display the Payment Screen
		paymentRequest.show().then((paymentResponse) => {
			var paymentInformation = this.getGooglePayPaymentInformation(paymentResponse);
			if (paymentInformation) {
				// Submit Checkout
				CheckoutActions.processPreTokenizedPaymentCheckout(
					paymentInformation,
					dataToSend,
					(successCallback) => this.dismissPaymentScreen(paymentResponse, "success"),
					(jqXHR) => this.failureCallback(jqXHR, paymentResponse),
					StringConstants.CheckoutTypes.GooglePay
				);
			} else {
				// Google displays errors to the user prior to dismissing the payment screen.
				var logMessage = paymentResponse && paymentResponse.details && paymentResponse.details.statusMessage;
				LoggerInstance.error(logMessage || googlePayErrorMessages.paymentCreationErrorLogMessage);

				this.dismissPaymentScreen(paymentResponse, "fail");
				Spinner.removeSpinner();
			}
		}).catch(exception => {
			// If the user manually closed (aborted) the Payment Screen, we should skip the alert message.
			if (exception && exception.name === "AbortError") {
				LoggerInstance.info(exception);
			} else {
				LoggerInstance.error(exception)
				BootstrapPrompt.alert(googlePayErrorMessages.paymentUnavailable);
			}

			Spinner.removeSpinner();
		});
	},

	getGooglePayPaymentInformation: function (paymentResponse) {
		var paymentInformation = null;
		var paymentMethodData = paymentResponse && paymentResponse.details && paymentResponse.details.paymentMethodData;
		var token = paymentMethodData && paymentMethodData.tokenizationData && paymentMethodData.tokenizationData.token;

		if (token) {
			var hostedPageToken = `GOOGLE_PAY|${token}`;
			var cardType = (paymentMethodData.info && paymentMethodData.info.cardNetwork || "").toUpperCase();
			var last4Digits = (paymentMethodData.info && paymentMethodData.info.cardDetails || "");
			var type = "CC";

			// Google Pay provides data for the following fields in the CombinedPaymentDto/PaymentContainer:
			paymentInformation = {
				hostedPageToken,
				cardType,
				last4Digits,
				type
			};
		}

		return paymentInformation;
	},

	failureCallback: function (jqXHR, paymentResponse) {
		// Display the error to the user
		ApiHelper.displayErrorMessage(jqXHR, /*fallbackMessage*/ null, /*isSafeToDisplayRequired*/ true);
		Spinner.removeSpinner();
		this.dismissPaymentScreen(paymentResponse, "fail");

		// Return true if the error was displayed to the user.
		return true;
	},

	dismissPaymentScreen: function (paymentResponse, completionStatus) {
		paymentResponse.complete(completionStatus);
	}
};